export default function() {
	const menuToggle = document.querySelector('[aria-controls="primary-menu"]');
	const mainNavigation = document.querySelector('.main-navigation');

	if (!menuToggle || !mainNavigation) {
		return;
	}

	menuToggle.addEventListener('click', () => {
		const isOpen = menuToggle.getAttribute('aria-expanded') === 'true';
		mainNavigation.classList.toggle('open', !isOpen);
		menuToggle.setAttribute('aria-expanded', String(!isOpen));
		document.body.classList.toggle('locked', !isOpen);
	});
}